import { createContext, useContext } from 'react';
import { PageInfo } from './types';

type PageInfoContextType = {
  pageInfo: PageInfo | null;
};

const PageInfoContext = createContext<PageInfoContextType>({ pageInfo: null });

type PageInfoContextProviderProps = {
  children: React.ReactNode;
  pageInfo: PageInfo | null;
};

export function PageInfoContextProvider({
  children,
  pageInfo,
}: PageInfoContextProviderProps) {
  return (
    <PageInfoContext.Provider value={{ pageInfo }}>
      {children}
    </PageInfoContext.Provider>
  );
}

export function usePageInfo() {
  const context = useContext(PageInfoContext);
  if (!context) {
    throw new Error(
      'usePageInfo must be used within a PageInfoContextProvider'
    );
  }
  return context;
}
